export enum NotificationPosition {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}
export enum NotificationType {
  Primary = 'primary',
  PrimaryDark = 'primary-dark',
  PrimaryInvert = 'primary-invert',
  Error = 'error',
  Default = 'default',
  Disabled = 'disabled',
}
